export default __webpack_public_path__ + "static/media/MySLR_overview.5cda7f94.mp4";